import React, { useState, useEffect, createContext } from 'react';
import { SearchInputCustom } from './SearchInputCustom';
import { SearchInputModal } from './SearchInputModal';
import { isClientEnv } from '@app/src/utils/validations';
import { DataListModel } from './DataListModel';
import { ErrorMessage } from './styled';
import { PredictiveInputCustom } from './PredictiveInputCustom';
import { PredictiveInputModal } from './PredictiveInputModal';

const isClient = isClientEnv();
const BREAKPOINT = 768;

interface Props {
  dataList?: DataListModel[];
  defaultUbigeo?: string;
  handleChange?: Function;
  handleClickClose?: Function;
  handleChangeInput?: Function;
  handleBlurInput?: Function;
  error?: string;
  disabled?: boolean;
  isLoading?: boolean;
  onDemand: boolean;
  input?: any;
  activeColor?: string;
}

export const PredictiveContext = createContext(null);

export const PredictiveConstructor: React.FC<Props> = props => {

  const [isResponsive, setIsResponsive] = useState(false);

  useEffect(() => {
    if (isClient) {
      handleResizeWindow();
      window.addEventListener('resize', handleResizeWindow);
      return () => {
        window.removeEventListener('resize', handleResizeWindow);
      }
    }
  }, []);

  const handleResizeWindow = () => {
    if (window.innerWidth >= BREAKPOINT) {
      setIsResponsive(false);
    } else {
      setIsResponsive(true);
    }
  }

  return (
    <React.Fragment>
      <PredictiveContext.Provider value={props}>
        {
          props.onDemand ?
            isResponsive ?
            <SearchInputModal />
            :
            <SearchInputCustom  />
          :
            isResponsive ?
            <PredictiveInputModal />
            :
            <PredictiveInputCustom  />
        }
      </PredictiveContext.Provider>
      {props.error && <ErrorMessage>{props.error}</ErrorMessage>}
    </React.Fragment>
)};
